

















import Vue, {VueConstructor} from 'vue'
import textareaInput from '../inputs/textarea.vue'
export default Vue.extend({
  name: 'textareaField',
  components: {textareaInput},
  props: {
    value: {},
    label: String,
    error: Boolean,
    field: String,
    placeholder: String,
    required: Boolean,
    options: {},
    hideDynPlaceholder: Boolean,
    disabled: Boolean
  },
  methods: {
    onInput (event: any): any {
      this.$emit('input', event)
    },
    onFocus (event: any): any {
      this.$emit('focus', event)
    },
    onBlur (event: any): any {
      this.$emit('blur', event)
    }
  },
  computed: {
    fieldValue: {
      get (): any {
        return this.value
      },
      set (): any {
      }
    } as any
  }
})
